var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"sg"}},[_c('a',{staticClass:"sr-only sr-only-focusable",attrs:{"href":"#gel-main"}},[_vm._v("Skip to main content")]),(_vm.$route.name != 'landing')?_c('div',[_c('Menu'),_c('Body')],1):_c('div',[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }